import styled from 'styled-components';
import { white, lightOrange, bgPurple } from 'constants/theme';

export const FooterContainer = styled.div`
  font-weight: 300;
  display: block;
  justify-content: space-between;
  background-color: ${bgPurple};
  line-height: 5rem;
  text-align: center;
  align-items: center;
  font-size: 48px;
  font-family: 'Helvetica';

  p {
    color: ${white};
    font-size: 16px;
    font-family: Roboto;
  }
  a.trial-page {
    color: ${white};
    font-size: 16px;
    font-family: Roboto;
  }
  .aut-copy {
    line-height: 20px;
    margin-bottom: 30px;
  }
  .aut-copy-last {
    line-height: 20px;
    margin-bottom: 40px;
  }

  .menu-links {
    flex-direction: row;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    color: white;
    font-size: 22px;
    font-family: Roboto;
    a {
      color: ${lightOrange};
      font-size: 16px;
      margin-left: 15px;
      margin-right: 15px;
    }
  }
  @media screen and (max-width: 740px) {
    .menu-links {
      margin-top: 20px;
      display: flex;
      flex-direction: column;
      color: ${bgPurple};
      line-height: 30px;
      margin-bottom: 30px;
    }
    .aut-copy {
      margin-bottom: 15px;
    }
    .aut-copy-last {
      margin-bottom: 30px;
    }
  }
`;
